export const todoGroup = {
  id: "todo",
  name: "待办",
  itemList: [
    {
      id: "verify",
      name: "我的审批",
      icon: "todo_verify",
      type: "TODO"
    },
    {
      id: "favorite",
      name: "我的收藏",
      icon: "todo_favorite",
      type: "TODO"
    }
  ]
}

export const operations = [
  {
    title: "新建分组",
    command: "group"
  },
  {
    title: "新建工作表",
    command: "sheet"
  },
  {
    title: "新建看板",
    command: "board"
  },
  {
    title: "添加链接",
    command: "link"
  }
]

export const unGroupMap = {
  SHEET: "工作表",
  DASHBOARD: "看板",
  URL: "链接"
}

export const unGroupKinds = ["SHEET", "DASHBOARD", "URL"]

export const groupTypeMap = {
  group: "分组",
  subGroup: "子分组"
}
